module.exports = __webpack_public_path__ + "static/img/email-expired.7e71ad6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/email-expired.png
// module id = 554
// module chunks = 1